import React from "react";
import DisplayData from "./display-data";

export default function ObjectDatatype({ value }) {
  let keys = Object.keys(value);
  return (
    <>
      <p style={{margin: 0}}>{`{`}</p>
      {keys.map((key, index) => (
        <p key={key} style={{ marginLeft: 10 }}>
          <span style={{ color: "grey" }}>{`${key}: `}</span>
          <DisplayData value={value[key]} inner={true} />
          {index !== keys.length - 1 && (<>,</>)}
        </p>
      ))}
      <p style={{margin: 0}}>{`}`}</p>
    </>
  );
}